import { Box, styled } from '@mui/material';

export const InfoBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.layout.spacing.small,
  border: `1px solid ${theme.greys.GREY0}`,
  borderRadius: 4,
  backgroundColor: theme.greys.GREYFA,
  padding: theme.layout.spacing.medium,
  display: 'flex',
  alignItems: 'center',
  gap: theme.layout.spacing.medium,
}));

export const ErrorBox = styled(InfoBox)(({ theme }) => ({
  border: `1px solid ${theme.colors.red}`,
  backgroundColor: theme.colors.redOpaque,
  color: theme.colors.red,
}));
